import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { mpdConstant } from "../constants/constants";


class MpdStore extends EventEmitter {
    constructor() {
        super();
        this.mpds = [];
        this.mpdWithProduct = [];
    }

    getAll() {
        return this.mpds;
    }

    getMpdsWithProduct() {
        return this.mpdWithProduct;
    }
    handleAction(action) {
        switch (action.type) {
            case mpdConstant.MPD_CREATED: {
                const { mpd } = action;
                this.mpds.push(mpd);
                this.emit(mpdConstant.MPD_CREATED, `MPD ${mpd.mpdName} created successfully.`);
                this.emit(mpdConstant.MPD_STORE_CHANGE);
                break;
            }
            case mpdConstant.MPD_CREATION_FAILED: {
                this.emit(mpdConstant.MPD_CREATION_FAILED, action.msg);
                break;
            }
            case mpdConstant.MPD_FETCHED_ALL: {
                //console.log("inside mpd store fetch all");
                this.mpds = action.data;
                this.emit(mpdConstant.MPD_STORE_CHANGE);
                break;
            }
            case mpdConstant.MPD_FETCHED_ALL_WITH_PRODUCT: {
                // console.log("aaaaaaaaaaaa", action.data);
                this.mpdWithProduct = action.data;
                this.emit(mpdConstant.MPD_FETCHED_ALL_WITH_PRODUCT);
                break;
            }
            case mpdConstant.FETCH_FAILED: {
                this.emit(mpdConstant.FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const mpdStore = new MpdStore();
window.mpdStore = mpdStore;
dispatcher.register(mpdStore.handleAction.bind(mpdStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
export default mpdStore;


// WEBPACK FOOTER //
// ./src/jsx/store/mpd-store.jsx